import { useEffect, useState } from "react";

import { debounce } from "lodash";

const MOBILE_SIZE = 768;
const TABLET_SIZE = 990;
const debounceTime = 500;

const useResponsive = () => {
  const [state, setState] = useState({
    isMobile: false,
    isTablet: false,
    isDesktop: false,
  });

  useEffect(() => {
    onResizeHandler();

    Setup();

    return () => {
      Cleanup();
    };
  }, []);

  const onResizeHandler = () => {
    const isMobile = window.innerWidth <= MOBILE_SIZE;
    const isTablet =
      window.innerWidth >= MOBILE_SIZE && window.innerWidth <= TABLET_SIZE;
    const isDesktop = window.innerWidth > TABLET_SIZE;

    setState({ isMobile, isTablet, isDesktop });
  };

  const debouncedCall = debounce(onResizeHandler, debounceTime);

  const Setup = () => {
    window.addEventListener("resize", debouncedCall, false);
  };

  const Cleanup = () => {
    window.removeEventListener("resize", debouncedCall, false);
  };

  return state;
};

export default useResponsive;
